<template>
  <div class="tutorial">
    <div class="tutorial_head">
      <div class="tutorial_label">{{ title }} 教程</div>
      <!-- <div class="tutorial_more">
                <img class="tutorial_more__img" src="@/assets/images/more.png" alt/>
            </div> -->
    </div>

    <!-- <ul class="tutorial_tool">
            <li v-for="(tool, index) in item.SubList" :key="index" 
            class="tutorial_tool__li"
            :class="{ active: index==curIndex }"
            @click="indexState(tool,index)">{{tool.Name}}</li>
        </ul> -->

    <div class="tutorial_hr"></div>

    <div class="tutorial_content">
      <div
        v-for="(tutorial, index) in item.SubList"
        :key="index"
        class="tutorial_div"
        @click="getTutorial(tutorial)"
      >
        <div class="tutorial_image">
          <img class="tutorial_image__img" :src="tutorial.Url" alt />
        </div>
        <div class="tutorial_title">
          {{ tutorial.Name }}
        </div>
        <div class="tutorial_desc">
          {{ tutorial.Description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "timeLine",
  props: {
    item: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      // 当前选择项
      curIndex: 0,
    };
  },
  watch: {},
  methods: {
    indexState(item, index) {
      this.curIndex = index;
    },
    // 教程页面
    getTutorial(tutorial) {
      var url = "";

      if(tutorial.hasOwnProperty("ExternalUrl") && tutorial.ExternalUrl != "") {
        url = tutorial.ExternalUrl;
      }
      else {
        url = "https://binschool.org/" + tutorial.Slug + "/" + tutorial.Slug + "-index.html";
      }

      window.open(url, "_blank");

      // var that = this;
      // that.$router.push({
      //     path: "/tutorialDetail",
      //     query: { category: tutorial.Slug }
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.tutorial {
  width: 100%;
  height: auto;
  margin: -30px 0 0 0;

  .tutorial_head {
    width: calc(100%);
    height: 29px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    margin: 0 0 0 0;
    padding: 60px 0 0 0;

    .tutorial_label {
      font-weight: normal;
      font-size: 16px;
      color: #6e6e6e;
      line-height: 29px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      width: 131px;
      height: 29px;
      border-radius: 8px 8px 8px 8px;
      background-color: rgba(65, 65, 65, 1);
      // border: 1px solid rgba(65, 65, 65, 1);
      color: #ffffff;
    }

    .tutorial_more {
      width: 80px;
      height: 30px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin: 0 0 0 40px;

      &__img {
        width: 60px;
        height: 28px;
        object-fit: contain;
        cursor: pointer;
      }
    }
  }

  .tutorial_tool {
    margin: 4px 0 0 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    &__li {
      width: auto;
      min-width: 131px;
      height: 29px;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #414141;

      font-weight: normal;
      font-size: 12px;
      color: #414141;
      line-height: 29px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      display: flex;
      justify-content: center;
      align-items: center;

      padding: 0 20px 0 20px;
      margin: 0 20px 0 0;
      cursor: pointer;
    }

    &__li:hover {
      border: 1px solid #689bff;
      color: #689bff;
    }

    .active {
      background-color: rgba(65, 65, 65, 1);
      border: 1px solid rgba(65, 65, 65, 1);
      color: #ffffff;
    }
  }

  .tutorial_hr {
    width: calc(100%);
    height: 1px;
    background: #e7e7e7;
    border-radius: 0px 0px 0px 0px;
    margin: 8px 0 9px 0;
  }

  .tutorial_content {
    display: flex;
    flex-wrap: wrap;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .tutorial_div {
      width: calc((100% - 26px) / 3);
      height: auto;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      margin: 0 13px 17px 0;

      cursor: pointer;

      .tutorial_image {
        width: 100%;
        height: auto;
        &__img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 8px 8px 0 0;
        }
      }

      .tutorial_title {
        width: calc(100% - 36px);
        height: 20px;

        font-weight: bold;
        font-size: 16px;
        color: #353535;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        text-transform: none;

        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        margin: 10px 18px 0 18px;
      }

      .tutorial_desc {
        width: calc(100% - 36px);
        height: 20px;

        font-weight: normal;
        font-size: 14px;
        color: #575757;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        text-transform: none;

        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        margin: 10px 18px 10px 18px;
      }
    }

    .tutorial_div:hover {
      box-shadow: 0px 15px 20px 0px rgba(20, 65, 153, 0.1);
      .tutorial_title {
        color: rgba(104, 155, 255, 1);
      }
    }

    .tutorial_div:nth-child(3n) {
      margin: 0 0 17px 0;
    }

    @media screen and (max-width: 1440px) {
      .tutorial_div {
        width: calc((100% - 13px) / 2);
      }

      .tutorial_div:nth-child(3n) {
        margin: 0 13px 17px 0;
      }

      .tutorial_div:nth-child(2n) {
        margin: 0 0 17px 0;
      }
    }

    @media screen and (max-width: 1120px) {
      .tutorial_div {
        width: calc(100%);
      }

      .tutorial_div:nth-child(n) {
        margin: 0 0 17px 0;
      }
    }

    @media screen and (max-width: 958px) {
      .tutorial_div {
        width: calc(100%);
      }

      .tutorial_div:nth-child(2n) {
        margin: 0 0 17px 0;
      }
      .tutorial_div:nth-child(n) {
        margin: 0 13px 17px 0;
      }
    }
  }
}

@media screen and (max-width: 958px) {
  .tutorial {
    width: 100%;
    height: auto;
    margin: -30px 0 0 0;

    .tutorial_head {
      width: calc(100%);
      height: 29px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 0 0 0 0;
      padding: 60px 0 0 0;

      .tutorial_label {
        font-weight: normal;
        font-size: 16px;
        color: #6e6e6e;
        line-height: 29px;
        text-align: center;
        font-style: normal;
        text-transform: none;

        width: 131px;
        height: 29px;
        border-radius: 8px 8px 8px 8px;
        background-color: rgba(65, 65, 65, 1);
        // border: 1px solid rgba(65, 65, 65, 1);
        color: #ffffff;
      }

      .tutorial_more {
        width: 80px;
        height: 30px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 0 0 0 40px;

        &__img {
          width: 60px;
          height: 28px;
          object-fit: contain;
          cursor: pointer;
        }
      }
    }

    .tutorial_tool {
      margin: 4px 0 0 10px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      &__li {
        width: auto;
        min-width: 131px;
        height: 29px;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #414141;

        font-weight: normal;
        font-size: 12px;
        color: #414141;
        line-height: 29px;
        text-align: center;
        font-style: normal;
        text-transform: none;

        display: flex;
        justify-content: center;
        align-items: center;

        padding: 0 20px 0 20px;
        margin: 0 20px 0 0;
        cursor: pointer;
      }

      &__li:hover {
        border: 1px solid #689bff;
        color: #689bff;
      }

      .active {
        background-color: rgba(65, 65, 65, 1);
        border: 1px solid rgba(65, 65, 65, 1);
        color: #ffffff;
      }
    }

    .tutorial_hr {
      width: calc(100%);
      height: 1px;
      background: #e7e7e7;
      border-radius: 0px 0px 0px 0px;
      margin: 8px 0 9px 0;
    }

    .tutorial_content {
      display: flex;
      flex-wrap: wrap;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .tutorial_div {
        width: calc((100% - 13px) / 2);
        height: auto;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        margin: 0 13px 17px 0;

        cursor: pointer;

        .tutorial_image {
          width: 100%;
          height: auto;
          &__img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 8px 8px 0 0;
          }
        }

        .tutorial_title {
          width: calc(100% - 36px);
          height: 20px;

          font-weight: bold;
          font-size: 16px;
          color: #353535;
          line-height: 22px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;

          margin: 10px 18px 0 18px;
        }

        .tutorial_desc {
          width: calc(100% - 36px);
          height: 20px;

          font-weight: normal;
          font-size: 14px;
          color: #575757;
          line-height: 20px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;

          margin: 10px 18px 10px 18px;
        }
      }

      .tutorial_div:hover {
        box-shadow: 0px 15px 20px 0px rgba(20, 65, 153, 0.1);
        .tutorial_title {
          color: rgba(104, 155, 255, 1);
        }
      }

      .tutorial_div:nth-child(2n) {
        margin: 0 0 17px 0;
      }

      @media screen and (max-width: 500px) {
        .tutorial_div {
          width: calc(100%);
        }

        .tutorial_div:nth-child(n) {
          margin: 0 0 17px 0;
        }
      }
    }
  }
}
</style>